module.exports = __webpack_public_path__ + "static/media/terms002.f19b7533.png";